import { Component, ViewChild, ElementRef } from '@angular/core';
import { RegisterFormService } from './register.form.service';
import { EmployerFormService } from '../../EmployerComponent/EmployerFormComponent/employer.form.service';
import { EmployerViewService } from '../../EmployerComponent/EmployerViewComponent/employer.view.service';
import { ProjectViewService } from '../../ProjectComponent/ProjectViewComponent/project.view.service';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { RegisterViewService } from '../RegisterViewComponent/register.view.service';
import { Countries } from '../../shared/countries/countries';

import { AppService } from '../../app.service';
import { Formvalidator } from './register.form.formvalidator';
import { PersonFormService } from '../../PersonComponent/PersonFormComponent/person.form.service';
import { ActivatedRoute } from '@angular/router'; 
import { formatDate } from '@angular/common';

import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';
import { AuthenticationService } from '../../auth';

@Component({
    selector: 'register-comp',
    providers: [RegisterFormService, Formvalidator, RegisterViewService, EmployerFormService, ProjectViewService, PersonFormService, ConfirmService, AppService,Countries,EmployerViewService, AuthenticationService], 
    templateUrl: './register.form.component.html',  
    styleUrls: ['../register.component.css']  
})

export class RegisterFormComponent {
    
    @ViewChild('validationModal') validationModal: ValidationModalComponent;   
  
    private activeComponent: boolean;
    employerSelected: boolean = false;
    registerControl: any;
    editRkBool: boolean = false;
    showTextInput: boolean = true;
    person: any;
    reasons: any = [];
    ready: boolean;
    company: any;
    projects: any = [];
    companies: any = [];
    suaCompanyAvailable: boolean;
    suaAvailable: boolean;
    personDetailsForm: FormGroup;
    personSsnSearch: FormGroup;
    suaDetailsForm: FormGroup;
    suaCompanyForm: FormGroup;
    personAvailable: String;
    @ViewChild('suaForm') public suaForm:ElementRef;
    type: any;
    ssn: any;

    constructor(
        private service: RegisterFormService,          
        private confirmService: ConfirmService,
        private personService: PersonFormService,
        private country: Countries,
        private formValidator: Formvalidator,
        private companyService: EmployerFormService,
        private activatedRoute: ActivatedRoute,
        private formBuilder: FormBuilder,
        private employerViewService: EmployerViewService,
        private registerService: RegisterViewService,
        private projectService: ProjectViewService,
        private appService: AppService,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated(); 
            this.activeComponent = appService.isComponentActive('registercontrol');
            this.type = this.activatedRoute.snapshot.paramMap.get('type');  
            this.ssn = this.activatedRoute.snapshot.paramMap.get('id');
            if(this.ssn != null && this.type === 'edit') {
                this.personAvailable = 'true';
                this.editRk();
            } else if (this.type === 'new') {
                this.setDefault();
                if(this.ssn != null) {
                    this.getPerson(this.ssn);
                }
            }          
        }

    /**
     * Initiates values
     */
    setDefault() {
        this.suaCompanyForm = new FormGroup({
            selectedCompany: new FormControl(),
            dummy: new FormControl()
        });

        this.suaDetailsForm = new FormGroup({
            companyName: new FormControl({disabled: false}),
            companyOrgId: new FormControl({disabled: false}),
            companyAddress: new FormControl({disabled: false}),
            companyPostCode: new FormControl({disabled: false}),
            companyCity: new FormControl({disabled: false}),
            companyPhone: new FormControl({disabled: false}),
            companySupplier: new FormControl(),
            companySuaProject: new FormControl()
        })

        this.personDetailsForm = new FormGroup({
            //Autofilled by person
            fullName: new FormControl({disabled: false}),
            currentAddress: new FormControl({disabled: false}),
            postalCode: new FormControl({disabled: false}),
            postalCity: new FormControl({disabled: false}),
            ssn: new FormControl({disabled: false}),
            currentCitizenship: new FormControl({disabled: false}),

            //To be filled by user
            birthplace: new FormControl(),
            profession: new FormControl(),
            oldCitizenship: new FormControl(),
            phoneDaytime: new FormControl(),
            otherAddress: new FormControl(),
            otherPostalAddress: new FormControl(),
            otherPostalCity: new FormControl(),
            otherPostalCode: new FormControl(),
            passportNumber: new FormControl(),
            latestAddressAbroad: new FormControl(),
            reasonText: new FormControl(),
            lastDate: new FormControl(),
            rkStatus: new FormControl(),
            //Radio's
            securityClass: new FormControl(),
            controlReason: new FormControl(),
            securityInterview: new FormControl(),
            suaAssignment: new FormControl()
        });

        this.personDetailsForm.patchValue({
            securityClass:'1',
            controlReason: 'Ospecificerad',
            securityInterview:'false',
            suaAssignment:'false',
            rkStatus:'Ej skickad'
        })

        this.personSsnSearch = new FormGroup({
            ssnInput: new FormControl()
        });

        
        this.projectService.getAllProjects().subscribe(
            data => this.setProjects(data),
            error =>  this.showError(error.error)      
        );
        this.ready = true;
    }

    /* Initiates forms before editing */
    editRk() {
        this.registerService.getRkById(this.ssn)      
            .subscribe(
                data => this.setData(data),
                error =>  this.showError(error.error)
            );
    }

    /* Patch form with known data */
    setData(data) {
        this.registerControl = data;
        this.person = data.person;

        this.setDefault();
        this.personDetailsForm.patchValue({
            fullName: data.fullName,
            ssn: data.person.ssn,
            postalCode: data.person.addresses[0].postCode,
            postalCity: data.person.addresses[0].city,
            currentAddress: data.person.addresses[0].address_1,
            currentCitizenship: data.nationality,
            birthplace: data.birthplace,
            profession: data.profession,
            oldCitizenship: data.oldCitizenship,
            phoneDaytime: data.phoneDaytime,
            otherAddress: data.otherAddress,
            otherPostalAddress: data.otherPostalAddress,
            otherPostalCity: data.otherPostalCity,
            otherPostalCode: data.otherPostalCode,
            passportNumber: data.passportNumber,
            latestAddressAbroad: data.latestAddressAbroad,
            reasonText: data.reasonText,
            lastDate: formatDate(data.lastDate, 'yyyy-MM-dd', 'en'),
            securityClass: data.rkClassification,
            controlReason: data.controlReason,
            securityInterview: data.securityInterview.toString(),
            suaAssignment: data.suaProject.toString(),
            rkStatus: data.status 
        });
        this.getCompanies(data.person.employers);
        this.suaCompanyForm.patchValue({
            selectedCompany: this.registerControl.employer.id
        });
        if(this.suaCompanyForm.get('selectedCompany').value != null) {
            this.employerSelected = true;
            this.showControlReason(this.suaCompanyForm.get('selectedCompany').value);
            
            if(this.personDetailsForm.get('suaAssignment').value) {
                this.showSelectedCompany(this.suaCompanyForm.get('selectedCompany').value);
                this.suaDetailsForm.patchValue({
                    companySuaProject: data.suaId
                })
            }
        }
        this.disablePersonInput();
        if(data.suaProject.toString() === 'true') {
            this.suaAvailable = true;
            this.suaDetailsForm.patchValue({
                companySuaProject: data.project.id,
                companySupplier: data.project.compSupplier
            });
        } else {
            this.suaAvailable = false;
        }
        
    }

    /** 
     * Retrieves a person based on the person id
     * @param personId Person identifier
     */
    getPerson(personId) {
        this.personService.getPersonBySsn(personId).subscribe(
            data => this.displayPerson(data),
            error =>  this.showError(error.error)
          );
    }

    /**
     * Prevents the user from modifying person data
     */
    disablePersonInput() {
        this.personDetailsForm.get('fullName').disable();
        this.personDetailsForm.get('postalCode').disable();
        this.personDetailsForm.get('ssn').disable();
        this.personDetailsForm.get('postalCity').disable();
        this.personDetailsForm.get('currentCitizenship').disable();
        this.personDetailsForm.get('currentAddress').disable();
        this.personDetailsForm.get('passportNumber').disable();
        this.personDetailsForm.get('profession').disable();
        this.personDetailsForm.get('phoneDaytime').disable();
    }

    /**
     * Show control reason 
     * @param employerId Identifier for employer to retrieve reasons from
     */
    showControlReason(employerId) {
        this.reasons.length = 0;
        
        //Kod för hantering av kontrollorsak
        /*this.personDetailsForm.get('reasonText').disable();
        
        for(let i=0; i < this.person.employers.length; i++) {
            if(this.person.employers[i].id === employerId) {
                for(let m=0; m < this.person.employers[i].projectList.length; m++) {
                    for(let o=0; o < this.person.employers[i].projectList[m].controlReason.length; o++) {
                        this.reasons.push(this.person.employers[i].projectList[m].controlReason[o].reason);
                    }
                }
            }
        }*/
        if(this.reasons.length >= 1) {
            this.showTextInput = false;
        } else {
            this.showTextInput = true;
        }

        this.personDetailsForm.get('reasonText').enable();
        this.employerSelected = true;
    }

    /**
     * Shows the RK for specified person
     * @param person 
     */
    displayPerson(person) {
        this.person = person;
        this.personAvailable = "true";
        this.getCompanies(this.person.employers);

        this.personDetailsForm.patchValue({
            fullName: person.lastName + ', ' + person.firstName.toUpperCase() + ' ' + person.middleName,
            ssn: person.ssn,
            postalCode: person.addresses[0].postCode,
            postalCity: person.addresses[0].city,
            currentAddress: person.addresses[0].address_1,
            currentCitizenship: this.country.get2CountryCodeName(person.nationalityCode),
            passportNumber: person.passportNumber,
            profession: person.profession,
            phoneDaytime: person.personPhoneNumber
        })
        this.disablePersonInput();
      
    }

    /**
     * Retrieves companies
     * @param personEmployer All employers for the specified person 
     */
    getCompanies(personEmployer) {
        this.companies.length = 0;
        this.suaAvailable = true;
        for(let i=0; i < personEmployer.length; i++){
            this.companyService.getEmployerById(personEmployer[i].id)      
            .subscribe(
              data => this.setCompanies(data),
              error =>  this.showError(error.error)      
            );
        }
    }

    /**
     * Disables sua
     */
    disableSua() {
        this.suaAvailable = false;
    }

    /**
     * Shows a selected company
     * @param company Company to be shown
     */
    showSelectedCompany(company) {
        let companySelected: any;
        for(let i=0; i < this.person.employers.length; i++) {
            if(this.person.employers[i].id === company) {
                companySelected = this.person.employers[i];
            }
        }
        this.showAndDisableCompanyInput(companySelected);
        this.suaAvailable = true;
    }

    /**
     * Shows and disables all company input fields in the form
     * @param companySelected Company which to alter
     */
    showAndDisableCompanyInput(companySelected) {
        this.suaDetailsForm.patchValue({
            companyName: companySelected.name,
            companyOrgId: companySelected.organisationId,
            companyAddress: companySelected.addresses[0].address_1,
            companyPostCode: companySelected.addresses[0].postCode,
            companyCity: companySelected.addresses[0].city,
            companyPhone: companySelected.contactPhone
        });

        this.suaDetailsForm.get('companyName').disable();
        this.suaDetailsForm.get('companyOrgId').disable();
        this.suaDetailsForm.get('companyAddress').disable();
        this.suaDetailsForm.get('companyPostCode').disable();
        this.suaDetailsForm.get('companyCity').disable();
        this.suaDetailsForm.get('companySupplier').disable();
        this.suaDetailsForm.get('companyPhone').disable();

        this.company = companySelected;
        this.suaCompanyAvailable = true;
    }

    /**
     * Set projects to selector list
     * @param data Projects
     */
    setProjects(data) {
        for(let i=0; i < data.length; i++) {
            if(data[i].suaCompanyStatus === 'SUA-godkänd') {
                this.projects.push(data[i]);
            }
        }
        //this.projects = data;
    }

    /**
     * Sets the SUA supplier on the RK form
     * @param project Project to retrieve supplier from
     */
    setCompanySupplier(projectId) {
        for(let i=0; i < this.projects.length; i++) {
            if(this.projects[i].id === projectId) {
                this.suaDetailsForm.patchValue({
                    companySupplier: this.projects[i].compSupplier
                });
                this.suaDetailsForm.get('companySupplier').disable();
            }
        }
    }

    /**
     * Function to move to content on page
     */
    moveToStructure():void {
        this.suaForm.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
    }

    /**
     * Sets all retrieved companies to list
     * @param data Retrieved companies from backend
     */
    setCompanies(data) {
        this.companies.push(data);
    }

    showError(error) {
        this.personAvailable = "notFound";
    }

    defaultBack() {
        this.appService.setRoute("/registercontrol/new");
    }

    /**
     * Called if attempting to leave the RK form while editing
     */
    back() {
        this.confirmService.confirm('Inga ändringar kommer sparas om du avbryter. Vill du fortsätta?')
            .then(result => {
                if (result) {
                    this.setDefault();
                    this.suaAvailable = false;
                    this.suaCompanyAvailable = false;
                    this.personAvailable = "false";
                }
                this.appService.setRoute('registercontrol/view/' + this.registerControl.id)
            });
    }

    /**
     * Save a new RK
     * @param registerForm   
     * @param suaForm 
     */
    saveRegisterControl(registerForm, suaForm, suaCompanyForm) {
        let rk = registerForm;
        rk.employerId = suaCompanyForm.selectedCompany;
        rk.status = this.personDetailsForm.get('rkStatus').value;
        rk.rkClassification = this.personDetailsForm.get('securityClass').value;
        rk.controlReason = this.personDetailsForm.get('controlReason').value;
        rk.securityInterview = this.personDetailsForm.get('securityInterview').value;
        rk.suaProject = this.personDetailsForm.get('suaAssignment').value;
        rk.fullName = this.personDetailsForm.get('fullName').value;
        rk.nationality = this.personDetailsForm.get('currentCitizenship').value;
        rk.personId = this.person.id;

        if(rk.suaProject == 'true') {
            if(suaForm.companySuaProject != null) {
                rk.suaId = suaForm.companySuaProject;
            }
        }

       if(this.formValidator.validatePersonForm(registerForm, suaCompanyForm, suaForm, this.validationModal.getModalArray())) {
            this.service.saveRk(rk)
            .subscribe(
                data => this.setRoute('registercontrol/view/' + data.id),
                error => this.showError(error.error)
            );
       } else {
           this.validationModal.pop();
       }
    }

    /**
     * Updates the RK
     * @param registerForm 
     * @param suaForm 
     */
    updateRegisterControl(registerForm, suaForm, suaCompanyForm) {
        let rk = registerForm;
        rk.employerId = suaCompanyForm.selectedCompany;
        rk.status = this.personDetailsForm.get('rkStatus').value;
        rk.id = this.registerControl.id;
        rk.fullName = this.personDetailsForm.get('fullName').value;
        rk.controlReason = this.personDetailsForm.get('controlReason').value;
        rk.securityInterview = this.personDetailsForm.get('securityInterview').value;
        rk.nationality = this.personDetailsForm.get('currentCitizenship').value;
        rk.rkClassification = this.personDetailsForm.get('securityClass').value;
        rk.suaProject = this.personDetailsForm.get('suaAssignment').value;
        rk.personId = this.person.id;
        rk.lastDate = formatDate(registerForm.lastDate, 'yyyy-MM-dd', 'en');
        
        if(rk.suaProject == 'true') {
            if(suaForm.companySuaProject != null) {
                rk.suaId = suaForm.companySuaProject;
            }
        }

        if(this.formValidator.validatePersonForm(registerForm, suaCompanyForm, suaForm, this.validationModal.getModalArray())) {
            this.service.updateRk(rk)
            .subscribe(
                data => this.setRoute('registercontrol/view/' + data.id),
                error => this.showError(error.error)
            );
        } else {
            this.validationModal.pop();
        }
    }

    setRoute(route) {
        this.appService.setRoute(route);
    }
    
    setRouteRk(ssn) {
        this.appService.setRoute('/registercontrol/new/'+ssn);
    }
    
    backToStart() {
        this.appService.setRoute('/registercontrol');
    }

  /**
   * Function for automatically formatting the ssn if the user does not format correctly
   * @param ssn the ssn to format and patch into the form
   */
  ssnFix(ssn) {
    if((ssn.length === 10 || ssn.length === 12) &&ssn[ssn.length-5] != "-") {
      ssn = ssn.substring(0, ssn.length-4) + "-" + ssn.slice(ssn.length-4);
    }
    if(ssn.replace("-", "").trim().length === 10) {
      if(ssn.replace("-", "").trim()[0] < 3) {
        ssn = "20" + ssn;
      } else {
        ssn = "19" + ssn;
      }
    }
    if(ssn.slice(ssn.length-2) === "tf") {
      ssn = ssn.substring(0, ssn.length-2) + "TF";
    }
    this.personSsnSearch.patchValue({
      ssnInput: ssn
    });
  }
}